module.exports = __webpack_public_path__ + "static/media/Home-T-02.6cc58c54.png";